import './App.css';
import Cookies from 'js-cookie';

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import NotFound from './components/NotFound';
import Home from './components/Home';
import CreateNewUser from './components/CreateNewUser';
import PlaidIntegration from './components/PlaidIntegration'
import ForgotPassword from './components/ForgotPassword';
import SuperAdminSignIn from './components/SuperAdmin/Signin';
import SuperAdminDashboard from './components/SuperAdmin/Dashboard';
import SuperAdminTransactionsPage from './components/SuperAdmin/Transactions';
import SuperAdminInstitutions from './components/SuperAdmin/InstitutionsandAccounts';

const PrivateRoutes = ({ requiredRole }) => {
  let role = localStorage.getItem("role");
  let jwt_token = Cookies.get('jwt_token');

  if (!jwt_token || (requiredRole && role !== requiredRole)) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
};
const PrivateRoutesSuperAdmin = ({ requiredRole }) => {
  let role = localStorage.getItem("role");
  let jwt_token = Cookies.get('jwt_token');

  if (!jwt_token || (requiredRole && role !== requiredRole)) {
    return <Navigate to="/super-admin" />;
  }

  return <Outlet />;
};
function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route exact path="/" element={<Home/>} />
          <Route exact path="/create-new-user" element={<CreateNewUser/>} />
          <Route exact path="/forgot-password" element={<ForgotPassword/>} />
          <Route exact path="/super-admin" element={<SuperAdminSignIn/>} />
          <Route element={<PrivateRoutes requiredRole="BASIC" />}>
            <Route exact path="/user" element={<PlaidIntegration/>} />
          </Route>
          <Route element={<PrivateRoutesSuperAdmin requiredRole="ADMIN" />}>
            <Route exact path="/super-admin/dashboard" element={<SuperAdminDashboard/>} />
            <Route exact path="/super-admin/user-institutions/:id" element={<SuperAdminInstitutions/>} />
            <Route exact path="/super-admin/account-transactions/:id" element={<SuperAdminTransactionsPage/>} />
          </Route>
          <Route path="*" element={<NotFound/>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
